import React from "react";
import './fragment_cancelled_trips_styles.scss';
import axios from "axios";
import {createApiServerRoute} from "../../../models/network/api_client";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import TableIndexColumn from "../../../components/table_component/table_index_column/table_index_column";
import TableTextualColumn from "../../../components/table_component/table_textual_column/table_textual_column";
import Table from "../../../components/table_component/table/table";
import TableHeader from "../../../components/table_component/table_header/table_header";
import TableHeading from "../../../components/table_component/table_heading/table_heading";
import TableBody from "../../../components/table_component/table_body/table_body";
import {actionSetCancelledTrips} from "../../../models/redux/reducers/activity_main_reducers/cancelled_trips_reducer/action_set_cancelled_trips";
import ChipsContainer from "../../../components/chip_component/chips_container/chips_container";
import Chip from "../../../components/chip_component/chip";
import {ACTIVITY_TAG, FRAGMENT_TAG} from "../../../utils/constants";
import UrlArgsBundle from "../../../core/url_args_bundle";

class CancelledTripsFragment extends React.Component {

    componentDidMount() {
        const params = new URLSearchParams();

        const config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        };
        axios.post(createApiServerRoute('get_all_cancelled_rides.php'), params, config)
            .then(res => {
                this.props.actionSetCancelledTrips(res.data.data.trips)
            });
    }

    getFragmentIntent = fragmentTag => {
        const urlArgsBundle = new UrlArgsBundle();
        urlArgsBundle.setActivityTag(ACTIVITY_TAG.MAIN).setFragmentTag(fragmentTag);
        return urlArgsBundle.getArgsAsUrlParams()
    }

    render() {
        return <div className="flex flex-col">
            <ChipsContainer>
                <Chip active={false} clickHandler={() => {this.props.history.push(this.getFragmentIntent(FRAGMENT_TAG.TRIPS))}}>Completed Trips</Chip>
                <Chip active={false} clickHandler={() => {this.props.history.push(this.getFragmentIntent(FRAGMENT_TAG.RUNNING_TRIPS))}}>Running Trips</Chip>
                <Chip active={true} clickHandler={() => {this.props.history.push(this.getFragmentIntent(FRAGMENT_TAG.CANCELLED_TRIPS))}}>Cancelled Trips</Chip>
            </ChipsContainer>
            <Table>
                <TableHeader>
                    <TableHeading>#</TableHeading>
                    <TableHeading>User</TableHeading>
                    <TableHeading>Ride Date</TableHeading>
                    <TableHeading>Pickup Location</TableHeading>
                </TableHeader>
                <TableBody>
                    {this.props.trips.map((d, index) => <tr key={d['trip_id']}>
                        <TableIndexColumn num={index + 1} clickHandler={() => {}} />
                        <TableTextualColumn text={`${d['passenger_first_name']} ${d['passenger_last_name']}`} />
                        <TableTextualColumn text={d['ride_date']} />
                        <TableTextualColumn text={d['pickup_location']} />
                    </tr>)}
                </TableBody>
            </Table>
        </div>
    }
}

const mapStateToProps = rootReducer => ({
    trips: rootReducer.cancelledTripsReducer.cancelledTrips
});

const mapDispatchToProps = dispatch => ({
    actionSetCancelledTrips: trips => dispatch(actionSetCancelledTrips(trips))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CancelledTripsFragment));
